'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
/**
 * Дни недели
 * */


var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactJss = require('react-jss');

var _reactJss2 = _interopRequireDefault(_reactJss);

var _clsx = require('clsx');

var _clsx2 = _interopRequireDefault(_clsx);

var _WeekDays = require('./WeekDays.style');

var _WeekDays2 = _interopRequireDefault(_WeekDays);

var _Label = require('../../Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var WeekDays = (_dec = (0, _reactJss2["default"])(_WeekDays2["default"]), _dec(_class = function (_PureComponent) {
  (0, _inherits3["default"])(WeekDays, _PureComponent);

  function WeekDays() {
    (0, _classCallCheck3["default"])(this, WeekDays);
    return (0, _possibleConstructorReturn3["default"])(this, (WeekDays.__proto__ || (0, _getPrototypeOf2["default"])(WeekDays)).apply(this, arguments));
  }

  (0, _createClass3["default"])(WeekDays, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isoDays = _props.isoDays,
          classes = _props.classes,
          size = _props.size,
          className = _props.className;
      var weekDayList = isoDays ? ['Mo', 'Tu', 'We', 'Tu', 'Fr', 'Sa', 'Su'] : ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
      return _react2["default"].createElement('div', {
        className: (0, _clsx2["default"])(className, classes[size], classes.weekDayList)
      }, weekDayList.map(function (weekDay, index) {
        return _react2["default"].createElement(_Label2["default"], {
          key: index,
          fontSize: size,
          className: (0, _clsx2["default"])(classes.weekDay),
          value: weekDay
        });
      }));
    }
  }]);
  return WeekDays;
}(_react.PureComponent)) || _class);
WeekDays.propTypes = {
  classes: _propTypes2["default"].object,

  /** additional external class name */
  className: _propTypes2["default"].string,

  /** WeekDays size */
  size: _propTypes2["default"].oneOf(['small', 'medium']).isRequired,

  /** WeekDays first day of the week is Monday by ISO-8601 */
  isoDays: _propTypes2["default"].bool.isRequired
};
exports["default"] = WeekDays;